import RiskDetails from './RiskDetails'

export default RiskDetails
